import '@src/App.css'
import { Header } from '@src/components/Header/Header'
import { configureLeaflet } from '@src/helpers/configureLeaflet'
import { MainPage } from '@src/pages/MainPage'
import { Provider } from '@src/components/ui/provider'
import { Separator } from '@chakra-ui/react'
import { MainPageStore, MainPageStoreContext } from '@src/pages/MainPageStore'
import { Toaster } from '@src/components/ui/toaster'

function App() {
    configureLeaflet()

    return (
        <Provider enableSystem={false}>
            <Header />
            <Separator />
            <MainPageStoreContext.Provider value={new MainPageStore()}>
                <MainPage />
            </MainPageStoreContext.Provider>
            <Toaster />
        </Provider>
    )
}

export default App
